export const canAccessRoute = (route, user) => {
  if (route?.rootOnly && String(user?.id) !== "1") return false;
  if (user?.tipoUser === "Administrador") {
    return route?.permiso !== "Empresa" || String(user.id) === "1";
  }
  if (route?.permissionId && ["Empleado", "Usuario"].includes(user?.tipoUser)) return Boolean(user?.permisos?.some(p => String(p.id) === String(route.permissionId)));
  if (route?.permiso === "Manifiestos") return ["Responsable", "Empresa"].includes(user?.tipoUser) || Boolean(user?.permisos?.some(item => item.pantalla === "Manifiestos"));
  return !route?.permiso || Boolean(user?.permisos?.some((item) => item.pantalla === route.permiso));
};
